import { render, staticRenderFns } from "./check-list-form.vue?vue&type=template&id=a065204e"
import script from "./check-list-form.vue?vue&type=script&lang=js"
export * from "./check-list-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports